<template>
<div class="container">
    <schoolAndDate :schoolName="schoolName" :dateTime="dateTime" />
    <div class="wrap">
        <div class="daily-type">
            <div class="daily-tr daily-header">
                <div>名称</div>
                <div>价格</div>
                <div>指导价</div>
                <div>比升降</div>
            </div>
        </div>
        <div class="overhide">
            <div class="unified-meal" ref="content" :style="`animation-duration:${animationDuration}s`">
                <div class="daily-type">
                    <div class="daily-tr daily-list" v-for="(subItem, subIndex) in zxcData" :key="subIndex">
                        <div>{{ subItem.name || '--' }}</div>
                        <div>{{ subItem.price.toFixed(2) || '--' }}</div>
                        <div>{{ subItem.guidePrice || '--' }}</div>
                        <div class="img-wrap">
                            <img class="img" :src="renderArrow(subItem.compareIncreaseDecrease)">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { TAB_MAP_VALUE } from '../assets/js/constants';
import schoolAndDate from "./schoolAndDate.vue";
export default {
    props: {
        deptId: {
            type: String,
            default: ''
        },
        outletsId: {
            type: String,
            default: ''
        },
        zxcData: {
            type: Array,
            default: () => [],
        },
        dateTime: {
            type: String,
            default: '',
        },
        schoolName: {
            type: String,
            default: '',
        },
    },
    components: { schoolAndDate, },
    data() {
        return {
            iconArrUp: require("@/assets/images/icon_arrow_up.png"),
            iconArrDown: require("@/assets/images/icon_arrow_down.png"),
            iconArrNot: require("@/assets/images/icon_arrow_not.png"),
            animationDuration: 0
        }
    },
    watch: {
        zxcData: function (newVal) {
            if (newVal && newVal.length > 0) {
                console.log(`===> (item=11) ${TAB_MAP_VALUE['11']} <===`,
                    JSON.parse(JSON.stringify(this.zxcData)))
                this.refreshPage()
            }
        },
    },
    computed: {},
    mounted() {
        setTimeout(() => {
            this.refreshPage()
        }, 1000)
    },
    methods: {

        refreshPage() {
            this.$nextTick(() => {
                this.calcDocumentHeight()
            })
        },

        renderArrow(value) {
            if (value === 'gt') {
                return this.iconArrUp
            }
            if (value === 'lt') {
                return this.iconArrDown
            }
            return this.iconArrNot
        },

        // 计算高度
        calcDocumentHeight() {
            if (this.$refs.content.offsetHeight > 900) {
                this.animationDuration = (this.$refs.content.offsetHeight / 200) * 2.5
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@keyframes scroll-up {
    0% {
        transform: translateY(vh(80));
        /* 文本初始位置，向上偏移 0 */
    }

    100% {
        transform: translateY(-100%);
        /* 文本最终位置，向上偏移 100%（等于滚动区域高度） */
    }
}

$tabStyleFontColor: #00048F;

$wrapHeight: 830;

.container {
    position: relative;
}
.wrap {
    height: vh($wrapHeight);
    width: 100%;
    border-radius: 4px;
    font-weight: bold;
    background: #b0f3f2;
    position: relative;
}

.daily-type {
    @include font(22, $tabStyleFontColor, center);

    .daily-title {
        color: $tabStyleFontColor;
        font-size: vh(32);
        margin: vh(40) auto vh(30);
    }

    .daily-tr {
        display: flex;

        >div {
            flex: 1;
        }

        >div:first-of-type {
            text-align: left;
            padding-left: vh(20);
            white-space: break-spaces;
        }

        &.daily-header {
            border-radius: 4px 4px 0 0;
            color: $tabStyleFontColor;
            background: #5DE7E8;
            padding: vh(12) 0;
            position: relative;
            z-index: 6;

            >div:first-of-type {
                transform: translateX(vh(30));
            }
        }

        &.daily-list {
            padding: vh(20) 0;
            border-bottom: 1px solid #4F82D7;
        }
    }

    .img {
        width: vh(14);
    }
}

.overhide {
    overflow: hidden;
    height: vh($wrapHeight - 50);
}

.unified-meal {
    display: flex;
    flex-direction: column;
    min-height: 100%;
    width: 100%;
    animation-name: scroll-up;
    animation-duration: 0;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
}
</style>